import React from 'react';
import { cn } from '@/lib/cn';

interface BaseProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

/**
 * SectionContainer - wraps a full section block with consistent spacing and optional header.
 * Applies the global `.section-container` utility and wraps children in `.section-content` by default.
 */
export function SectionContainer({ children, className, ...props }: BaseProps) {
  return (
    <section className={cn('section-container', className)} {...props}>
      {children}
    </section>
  );
}

/**
 * SectionContent - applies consistent horizontal padding for section bodies.
 * Uses the global `.section-content` utility.
 */
export function SectionContent({ children, className, ...props }: BaseProps) {
  return (
    <div className={cn(className, 'section-content')} {...props}>
      {children}
    </div>
  );
}

/**
 * DynamicGridContainer - responsive two-column layout wrapper (left content + optional sticky right).
 * Applies the global `.dynamic-grid-container` utility.
 */
export function DynamicGridContainer({ children, className, ...props }: BaseProps) {
  return (
    <div className={cn('dynamic-grid-container', className)} {...props}>
      {children}
    </div>
  );
}
